export default function ExploreMore({ exploreMore, switchTab }) {
  return (
    <div
      className="technical-container"
      style={{
        gap: 15,
        marginTop: 0,
        cursor: "pointer",
        marginTop: "20px",
      }}
      onClick={() => {
        window.scrollTo(0, 0);
        switchTab("trending");
      }}
    >
      <h3
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: "20px",
          color: "#1D3557",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          padding: "20px 0px 20px 20px",
          borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
          // marginBottom: 20,
        }}
      >
        See What's Trending
      </h3>
      <table style={{ width: "100%" }}>
        <thead>
          <th
            style={{
              padding: 5,
              color: "#1D3557",
              borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
            }}
          >
            Ticker
          </th>
          <th
            style={{
              padding: 5,
              color: "#1D3557",
              borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
            }}
          >
            Views
          </th>
          <th
            style={{
              padding: 5,
              color: "#1D3557",
              borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
            }}
          >
            Live Price
          </th>
        </thead>
        {exploreMore &&
          exploreMore.map((item) => (
            <tr
              key={item[1]}
              style={{
                padding: 5,
                borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
              }}
            >
              <td
                style={{
                  fontWeight: "600",
                  fontSize: 16,
                  textAlign: "center",
                  borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
                  color: "#1D3557",
                }}
              >
                {item[1]}
              </td>
              <td
                style={{
                  fontWeight: "400",
                  fontSize: 16,
                  opacity: 0.75,
                  textAlign: "center",
                  padding: 5,
                  borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
                }}
              >
                {item[2] && item[2].length > 0 ? (
                  <span
                    style={{
                      fontSize: window.innerWidth <= 480 ? 14 : 15,
                    }}
                  >
                    {(() => {
                      // Filter out usernames containing IP addresses and specific names
                      const validUsers = item[2].filter(
                        (user) =>
                          !user.match(/\b(?:\d{1,3}\.){3}\d{1,3}\b/) &&
                          !user.includes("Ashim") &&
                          !user.includes("Bhushan")
                      );
                      if (validUsers.length > 0) {
                        // Format the username to show first name and last initial
                        const nameParts = validUsers[0].trim().split(" ");
                        const formattedName =
                          nameParts.length > 1
                            ? `${nameParts[0]} ${
                                nameParts[nameParts.length - 1][0]
                              }.`
                            : nameParts[0];
                        return (
                          <>
                            {formattedName}
                            {item[3] > 1 && ` +${item[3] - 1}`}
                          </>
                        );
                      }
                      // If no valid names to show, just show the total views
                      return `${item[3]} view${item[3] > 1 ? "s" : ""}`;
                    })()}
                  </span>
                ) : (
                  item[3]
                )}
              </td>
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: 5,
                  borderBottom: "1px solid rgba(0, 0, 0, 0.15)",
                }}
              >
                <div
                  style={{
                    fontFamily: "Inter",
                    backgroundColor:
                      parseFloat(item[5]) > 0
                        ? "rgba(19, 156, 141, 0.075)"
                        : parseFloat(item[5]) < 0
                        ? "rgba(255, 0, 0, 0.075)"
                        : "rgba(85, 85, 85, 0.075)",
                    color:
                      parseFloat(item[5]) > 0
                        ? "#139C8D"
                        : parseFloat(item[5]) < 0
                        ? "rgb(255, 76, 97)"
                        : "#555",
                    padding: "7.5px 10px",
                    borderRadius: "5px",
                    fontSize: window.innerWidth <= 480 ? "14px" : "16px",
                  }}
                >
                  {String(item[4]) === "null" || String(item[5]) === "null"
                    ? "Unable to fetch live data"
                    : `$${
                        parseFloat(item[4])
                          ? parseFloat(item[4]).toFixed(2)
                          : "N/A"
                      } (${item[5]}%)`}
                </div>
              </td>
            </tr>
          ))}
      </table>
    </div>
  );
}
